import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getAnalises = () => async (dispatch) => {
    dispatch({
        type: 'ANALISYS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisys/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const getAnalisys = (analisys) => async (dispatch) => {
    dispatch({
        type: 'ANALISYS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisys/get/'+ analisys, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYS_GET_SUCCESS',
                payload: data.analisys
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const getAnalisysByWorkOrder = (workOrderId) => async (dispatch) => {
    dispatch({
        type: 'ANALISYS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisys/getbyworkorder/'+ workOrderId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYS_GET_SUCCESS',
                payload: data.analisys
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const getAnalisysWithPendings = (parameterReferenced) => async (dispatch) => {
    dispatch({
        type: 'ANALISYS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/analisys/getwithpendings/'+ parameterReferenced, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'ANALISYS_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const addAnalisys = (analisysdata) => async (dispatch) => {
    dispatch({
        type: 'ANALISYS_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/analisys/register', analisysdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'ANALISYS_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const editAnalisys = (analisysdata, idAnalisys) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/analisys/edit/' + idAnalisys, analisysdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'ANALISYS_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'WORKORDER_EDIT_SUCCESS',
                payload: {quantityMeasures: analisysdata.measures.length, workOrderId: analisysdata.workOrder._id}
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_ERROR'
        })
    }
}

export const updatePendingParams = (updates) => async (dispatch) => {
    try {
        const { data, status} = await Axios.put('/api/analisys/updatependings', updates, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'ANALISYS_UPDATE_PENDING_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_ERROR'
        })
    }
}

export const removeAnalisys = (analisys) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/analisys/remove/' + analisys, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        })
        if (status === 200 || status === 263) {
            dispatch({
                type: 'ANALISYS_REMOVE_RESULT',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'ANALISYS_NOT_LOADING'
        })
    }
}

export const resetAnalisys = () => async (dispatch) => {
    dispatch({
        type: 'ANALISES_RESET'
    })
}